<div class="button-holder">
  <div
    [ngClass]="
      isActive ? 'button-container active' : 'button-container deactive'
    "
    (click)="clicked($event)"
    id="radio-button"
  >
    <div class="radio-button-title">{{ config.title }}</div>
    <div *ngIf="isActive" class="check-box check-box-active">
      <img class="check-box-img" src="assets/general/tick-blue.png" />
    </div>
    <div *ngIf="!isActive" class="check-box check-box-disable"></div>
  </div>
</div>
